<template>
  <div>
    <ViewEvolution
      title="EVOLUÇÃO MUSICOTERAPIA"
      type="MUSICOTERAPIA"
      :resident_id="resident_id"
    />
  </div>
</template>

<script>
import routes from "../../../routes";

import ViewEvolution from "../../Evolution/View";

export default {
  name: "Evolution",
  components: {
    ViewEvolution,
  },
  data() {
    return {
      resident_id: "",
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    retrieve() {
      const { id } = routes.history.current.params;
      this.resident_id = id;
    },
  },
};
</script>